export const getInternalSignInPath = () => {
  let signInPath = '/signin';

  const redirectUrl = encodeURIComponent(window.location.href);
  signInPath = `${signInPath}?redirectUrl=${redirectUrl}`;

  return signInPath;
};
